import {connect} from "react-redux"
import getRealmFromHeaders from "../../../../utils/getRealmFromHeaders"
import State from "../../../../models/State"

export const mapStateToProps = (state: State) => {
    const {url, headers, urlIsSaleOrClearance} = state.request
    const {breadcrumbs, breadcrumbsValues} = state.search
    const {text} = state
    const realm = getRealmFromHeaders(headers)
    return {
        url,
        breadcrumbs,
        breadcrumbsValues,
        text,
        realm,
        urlIsSaleOrClearance,
    }
}

export default connect(mapStateToProps)
